import React from 'react';
import styled from 'styled-components';
import Tippy from '@tippyjs/react';

import { isBrowser } from '@tager/web-core';

import Lock from '@/assets/svg/lock.svg';
import { colors } from '@/constants/theme';

interface Props {
  disabledHint: string | undefined;
}

function TippyLockIcon({ disabledHint }: Props) {
  return (
    <Component>
      <Tippy
        content={<DisabledHint>{disabledHint}</DisabledHint>}
        interactive
        placement="bottom"
        appendTo={isBrowser() ? document.body : 'parent'}
      >
        <IconWrapper>
          <Lock />
        </IconWrapper>
      </Tippy>
    </Component>
  );
}

export default TippyLockIcon;

const Component = styled.div``;

const DisabledHint = styled.div`
  color: ${colors.black};
  padding: 10px;
  box-shadow: 0 4px 19px rgb(21 27 38 / 13%);
  border: 0.5px solid ${colors.gray400};
  border-radius: 8px;
  font-weight: 300;
  font-size: 14px;
  line-height: 130%;
  background: ${colors.white};
`;

const IconWrapper = styled.div`
  svg {
    path {
      fill: ${(props) => props.theme.main};
    }
  }
`;
